import React from "react";
import { useState } from "react";
import { FaSearch } from "react-icons/fa";
import { FaDollyFlatbed } from "react-icons/fa";
import { FaFacebookF } from "react-icons/fa";
import { FaInstagramSquare } from "react-icons/fa";
import { Link, Outlet } from "react-router-dom";
import "./Addcart.css";
import Card from ".././Card/Card";

function Addcart() {
  const [num, setNum] = useState(0);

  function increament() {
    setNum(num + 1);
  }
  function decreament() {
    if (num > 0) {
      setNum(num - 1);
    } else {
      alert("Sorry, No More Decreament value!");
    }
  }

  const [selectedImage, setSelectedImage] = useState(null);

  const images = [
    { id: 1, src: "./image/readywear/6.jpg", alt: "Image 1" },
    { id: 2, src: "./image/readywear/5.jpg", alt: "Image 2" },
    { id: 3, src: "./image/readywear/4.jpg", alt: "Image 3" },
  ];

  const handleClick = (imageId) => {
    const selected = images.find((image) => image.id === imageId);
    setSelectedImage(selected);
  };

  return (
    <>
      <div className="container cart">
        <div className="row">
          <div className="col-md-6">
            <div className="selected-image">
              <img className="w-100 p-3" src="./image/readywear/4.jpg" alt="" />
            </div>

            <div className="image-list">
              {images.map((image) => (
                <img
                  className="pic_change_cart"
                  key={image.id}
                  src={image.src}
                  alt={image.alt}
                  onClick={() => handleClick(image.id)}
                />
              ))}
            </div>
          </div>
          <div className="col-md-6 ">
            <div className="cart_2">
              <h2 className="card-heading ">Boski</h2>
              <div className="cart_price">
                <del className="boski_price del">Rs.1200</del>
                <h4 className="boski_price"> Rs 10,000</h4>
              </div>

              <hr />
              <div className="size">
                <p>Size</p>
                <select className="large" name="Size" id="large-medium">
                  <option value="L">L</option>
                  <option value="M">M</option>
                </select>
              </div>

              <div className="color d-flex">
                <p>Color</p> <input className="large" type="color" />
              </div>
              <hr />
              <div className="count d-flex">
                <div className="maincout">
                  <button className="increament" onClick={decreament}>
                    -
                  </button>
                  <p className="countnum">{num}</p>
                  <button className="increament" onClick={increament}>
                    +
                  </button>
                </div>
                <Link to="/checkout" className="">
                  <button className="Buy py-3">Buy Now</button>
                </Link>
              </div>
              <br />
              <br />
              <div className="size_add">
                <p className="ADDWISHLIST">ADD TO WISHLIST</p>
                <p className="ADDCOMPARE">ADD TO COMPARE</p>
              </div>
              <hr />

              <div className="cate">
                <p>SKU:N/A</p>
                <p>Category: Wash & Wear</p>
              </div>
              <hr />
              <div>
                <Link to="#">
                  <FaSearch className="search" />{" "}
                </Link>
                <Link to="#">
                  <FaDollyFlatbed className="dolly" />{" "}
                </Link>
                <Link to="#">
                  {" "}
                  <FaFacebookF className="facebook" />{" "}
                </Link>
                <Link to="#">
                  <FaInstagramSquare className="instagram" />
                </Link>
                <Outlet />
              </div>
            </div>
          </div>
        </div>
        <hr />
        <>
          <h3 className="related-heading">YOU MAY ALSO LIKE</h3>
          <div className=" related">
            <div className="container">
              <div class="row">
                <div class="col-md-4">
                <Link to="/addcart">
                  <Card
                    imgUrl2="./image/wear.jpg"
                    img="./image/swiss.jpg"
                    title="Ready To Wear"
                  />
                  </Link>
                </div>
                <div class="col-md-4">
                <Link to="/addcart">
                  <Card
                    imgUrl2="./image/swiss.jpg"
                    img="./image/wear.jpg"
                    title="SWISS LAWN"
                  />
                  </Link>
                </div>
                <div class="col-md-4">
                <Link to="/addcart">
                  <Card
                    img="./image/swiss.jpg"
                    imgUrl2="./image/dupattas.jpg"
                    title="DUPATTAS"
                  />
                  </Link>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                <Link to="/addcart">
                  <Card
                    img="./image/chantele.jpg"
                    imgUrl2="./image/dupattas.jpg"
                    title="CHANTELLE"
                  />
                  </Link>
                </div>
                <div class="col-md-4">
                <Link to="/addcart">
                  <Card
                    img="./image/bottoms.jpg"
                    imgUrl2="./image/dupattas.jpg"
                    title="BOTTOMS"
                  />
                  </Link>
                </div>
                <div class="col-md-4">
                    <Link to="/addcart">
                  <Card
                    img="./image/special.jpg"
                    imgUrl2="./image/dupattas.jpg"
                    title="SPECIAL PRICE"
                  /></Link>
                </div>
              </div>
            </div>
          </div>
        </>
      </div>
    </>
  );
}

export default Addcart;
